var moduleMap = {
	"./crmApp": () => {
		return Promise.all([__webpack_require__.e(8776), __webpack_require__.e(5463), __webpack_require__.e(1442), __webpack_require__.e(3644), __webpack_require__.e(6643), __webpack_require__.e(886), __webpack_require__.e(2125), __webpack_require__.e(5750), __webpack_require__.e(6741), __webpack_require__.e(4450), __webpack_require__.e(9241), __webpack_require__.e(3043), __webpack_require__.e(5405)]).then(() => (() => ((__webpack_require__(3043)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});